export const highRiskAccountOptions = {
  onlyScore: {
    kpiScore: true,
    licenseUtilization: false,
    kpiTrend: false,
    value: 'healthScore <= kpiScoreValue',
  },
  onlyUtil: {
    kpiScore: false,
    licenseUtilization: true,
    kpiTrend: false,
    value: 'assignedSeatsPercent <= licenseUtilizationValue',
  },
  onlyDecline: {
    kpiScore: false,
    licenseUtilization: false,
    kpiTrend: true,
    value: 'healthScoreTrend === "falling"',
  },
  // -----
  scoreAndUtil: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: false,
    value: 'healthScore <= kpiScoreValue && assignedSeatsPercent <= licenseUtilizationValue',
  },
  scoreOrUtil: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: false,
    value: 'healthScore <= kpiScoreValue || assignedSeatsPercent <= licenseUtilizationValue',
  },
  // -----
  scoreAndDecline: {
    kpiScore: true,
    licenseUtilization: false,
    kpiTrend: true,
    value: 'healthScore <= kpiScoreValue && healthScoreTrend === "falling"',
  },
  scoreOrDecline: {
    kpiScore: true,
    licenseUtilization: false,
    kpiTrend: true,
    value: 'healthScore <= kpiScoreValue || healthScoreTrend === "falling"',
  },
  // -----
  utilAndDecline: {
    kpiScore: false,
    licenseUtilization: true,
    kpiTrend: true,
    value: 'assignedSeatsPercent <= licenseUtilizationValue && healthScoreTrend === "falling"',
  },
  utilOrDecline: {
    kpiScore: false,
    licenseUtilization: true,
    kpiTrend: true,
    value: 'assignedSeatsPercent <= licenseUtilizationValue || healthScoreTrend === "falling"',
  },
  // ----
  scoreAndDeclineOrUtil: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: true,
    value: '(healthScore <= kpiScoreValue && healthScoreTrend === "falling") || assignedSeatsPercent <= licenseUtilizationValue',
  },
  scoreOrDeclineAndUtil: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: true,
    value: 'healthScore <= kpiScoreValue || (healthScoreTrend === "falling" && assignedSeatsPercent <= licenseUtilizationValue)',
  },
  scoreAndUtilOrDecline: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: true,
    value: '(healthScore <= kpiScoreValue && assignedSeatsPercent <= licenseUtilizationValue) || healthScoreTrend === "falling"',
  },
  scoreOrUtilAndDecline: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: true,
    value: '(healthScore <= kpiScoreValue || assignedSeatsPercent <= licenseUtilizationValue) && healthScoreTrend === "falling"',
  },
  // -----
  scoreOrUtilOrDecline: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: true,
    value: 'healthScore <= kpiScoreValue || assignedSeatsPercent <= licenseUtilizationValue || healthScoreTrend === "falling"',
  },
  scoreAndUtilAndDecline: {
    kpiScore: true,
    licenseUtilization: true,
    kpiTrend: true,
    value: '(healthScore <= kpiScoreValue && assignedSeatsPercent <= licenseUtilizationValue) && healthScoreTrend === "falling"',
  },
};

export const highRiskAccountMetric = [
  { name: 'Low Score', value: 'onlyScore' },
  { name: 'Low Utilization', value: 'onlyUtil' },
  { name: 'Declining Trend', value: 'onlyDecline' },

  { name: 'Low Score and Low Utilization', value: 'scoreAndUtil' },
  { name: 'Low Score or Low Utilization', value: 'scoreOrUtil' },
  { name: 'Low Score and Declining Trend', value: 'scoreAndDecline' },
  { name: 'Low Score or Declining Trend', value: 'scoreOrDecline' },
  { name: 'Low Utilization and Declining Trend', value: 'utilAndDecline' },
  { name: 'Low Utilization or Declining Trend', value: 'utilOrDecline' },

  { name: 'Low Score and Declining Trend or Low Utilization', value: 'scoreAndDeclineOrUtil' },
  { name: 'Low Score or Declining Trend and Low Utilization', value: 'scoreOrDeclineAndUtil' },
  { name: 'Low Score and Low Utilization or Declining Trend', value: 'scoreAndUtilOrDecline' },
  { name: 'Low Score or Low Utilization and Declining Trend', value: 'scoreOrUtilAndDecline' },

  { name: 'Low Score or Low Utilization or Declining Trend', value: 'scoreOrUtilOrDecline' },
  { name: 'Low Score and Low Utilization and Declining Trend', value: 'scoreAndUtilAndDecline' },
];

export const generateMenuItems = (start, end) => {
  const result = [];
  for (let i = start; i <= end; i++) {
    result.push(i.toString());
  }
  return result;
};
